import { createFileRoute } from '@tanstack/react-router';
import { NotificationSendDetail } from '@/components/admin/notifications/history/NotificationSendDetail.tsx';

export const Route = createFileRoute('/_app/admin/notifications/history/$sendId')({
  staticData: { orgScope: 'record', orgScopeList: '/admin/notifications/history' },
  component: NotificationSendRoute,
});

function NotificationSendRoute() {
  const { sendId } = Route.useParams();
  return <NotificationSendDetail key={sendId} sendId={sendId} />;
}
